const Inventory = [
  {
    path: '/ecommerce/inventory',
    name: 'category',
    component: () => import(/* webpackChunkName: "catalog-base" */ './CatalogView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'All Category',
          path: '/ecommerce/inventory/categories',
        },
      ],
    },
    children: [
      {
        path: 'categories',
        name: 'category',
        component: () => import(/* webpackChunkName: "category" */ './components/Category.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Categories',
              path: '/ecommerce/inventory/categories',
            },
          ],
        },
      },
      {
        path: 'sub-categories',
        name: 'all-subcategory',
        component: () => import(/* webpackChunkName: "sub-category" */ './components/SubCategory.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Categories',
              path: '/ecommerce/inventory/categories',
            },
            {
              name: 'Sub Categories',
              path: '',
            },
          ],
        },
      },
      {
        path: 'category/:id/subcategory',
        name: 'subcategory',
        component: () => import(/* webpackChunkName: "sub-category-with-id" */ './components/SubCategory.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Categories',
              path: '/ecommerce/inventory/categories',
            },
            {
              name: 'Sub Categories',
              path: '',
            },
          ],
        },
      },
      {
        path: 'micro-categories',
        name: 'all-micro-category',
        component: () => import(/* webpackChunkName: "micro-category" */ './components/MicroCategory.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Categories',
              path: '/ecommerce/inventory/categories',
            },
            {
              name: 'Sub Categories',
              path: '/ecommerce/inventory/sub-categories',
            },
            {
              name: 'Micro-Categories',
              path: '',
            },
          ],
        },
      },
      {
        path: 'category/:category_id/subcategory/:subCategory_id/micro-category',
        name: 'micro-category',
        component: () => import(/* webpackChunkName: "micro-category-with-id" */ './components/MicroCategory.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Categories',
              path: '/ecommerce/inventory/categories',
            },
            {
              name: 'Sub categories',
              path: '/ecommerce/inventory/sub-categories',
            },
            {
              name: 'Micro Categories',
              path: '',
            },
          ],
        },
      },
    ],
  },
];

export default Inventory;
